import { render, staticRenderFns } from "./tit-wrap.vue?vue&type=template&id=160ab45b&scoped=true&"
import script from "./tit-wrap.vue?vue&type=script&lang=js&"
export * from "./tit-wrap.vue?vue&type=script&lang=js&"
import style0 from "./tit-wrap.vue?vue&type=style&index=0&id=160ab45b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160ab45b",
  null
  
)

export default component.exports